export default String.raw`
const Availability = (() => {
    'use strict';
    const getCollectionPointCities = async () => {
        const data = {
            __csrf: __CSRF,
            __action: 'Get/CollectionPointCities',
            stockLevels: true
        };

        try {
            const response = await $.get('', data);

            if(response?.action?.Code != 0) {
                app.temporaryPopupMessage(undefined, response.action.Message, response.action.Type);
                return;
            }

            const cities = response?.action?.Object;
    
            if(!cities || cities.length === 0) {
                return [];
            }

            return cities;
        } catch (error) {
            console.error("Error fetching collection point cities: ", error);
        }
    };

    const getCollectionPointDetails = async (city, products) => {
        const data = {
            __csrf: __CSRF,
            __action: 'Product/CollectionPointsStockLevelsGet',
            city: city,
            products: JSON.stringify(products)
        }

        try {
            const response = await $.post('', data);

            if(response?.action?.Code != 0) {
                app.temporaryPopupMessage(undefined, response.action.Message, response.action.Type);
                return;
            }

            const result = response?.action?.Object;
    
            if (!result || result.length === 0) {
                return [];
            }

            return result;
        } catch (error) {
            console.error("Error fetching collection point details: ", error);
        }
    };

    return {
        getCollectionPointCities,
        getCollectionPointDetails
    }
})();

const AvailabilityUI = (() => {
    'use strict';
    const button = document.querySelector('.check-availability-js');

    if (!button) {
        return;
    }

    $('body').on('click', '.check-availability-js', async () => {
        const popup = document.querySelector('.check-availability-popup-js');
        const cities = await Availability.getCollectionPointCities();

        if (!cities || cities?.length === 0) {
            popup.showModal();
            return;
        }

        let options = '<option value="none" selected disabled hidden></option>';
        options += cities.map(city => '<option value="'+ city + '">'+ city +'</option>').join('');
        $('.check-availability-popup-js select').html(options);
        popup.showModal();
    });

    const select = document.querySelector('.check-availability-popup-js select');

    if (!select) {
        return;
    }

    $('body').on('change', '.check-availability-popup-js select', async (e) => {
        const city = $(e.currentTarget).val();
    
        if (!city) {
            return;
        }

        const productId = $('.product-presentation-js').data('product-id');
        const supplyId = $('.product-presentation-js').find('.active-js input[name="supplyId"]').val();
    
        // If supplyId exists, use it as ProductId and set SupplyId to null
        // Otherwise use productId as ProductId
        let finalProductId;
        
        if (supplyId && !isNaN(supplyId)) {
            finalProductId = Number(supplyId);
        } else if (!isNaN(productId)) {
            finalProductId = Number(productId);
        } else {
            finalProductId = null
        }
        
        const products = [{ 
            ProductId: finalProductId, 
            SupplyId: null 
        }];

        const result = await Availability.getCollectionPointDetails(city, products);
        const template = document.querySelector('#check-availability-template');
        const list = document.querySelector('.check-availability-list-js');
        list.innerHTML = '';
        
        result.forEach(item => {
            const clonedTemplate = template.content.cloneNode(true);
            const collectionPoint = item.CollectionPoint;
            const pointProducts = item.Products;
        
            const nameElements = clonedTemplate.querySelectorAll('[data-key="Name"]');
            nameElements.forEach(element => {
                if (element) {
                    element.textContent = collectionPoint.Name ?? '';
                }
            });

            const valueElement = clonedTemplate.querySelector('[data-key="Value"]');
            if (valueElement) {
                const hasProducts = pointProducts && pointProducts.length > 0;
                let quantity = 0;
                if (hasProducts) {
                    quantity = pointProducts[0].Value ?? 0;
                }
                const showAsNumbers = __checkAvailabilityInShopPresentation === 'numbers';
                const isAvailable = hasProducts && quantity > 0;
                
                if (showAsNumbers && isAvailable) {
                    valueElement.textContent = quantity;
                } else if (showAsNumbers) {
                    valueElement.textContent = '0';
                } else if (isAvailable) {
                    valueElement.dataset.value = quantity;
                    valueElement.textContent = __translations.Available;
                } else {
                    valueElement.dataset.value = '0';
                    valueElement.textContent = __translations.NotAvailable;
                }
            }
        
            const streetElement = clonedTemplate.querySelector('[data-key="Street"]');
            if (streetElement) {
                streetElement.textContent = collectionPoint.Street ?? '';
            }
        
            const streetNoElement = clonedTemplate.querySelector('[data-key="StreetNo"]');
            if (streetNoElement) {
                streetNoElement.textContent = collectionPoint.StreetNo ?? '';
            }
        
            const unitNoElement = clonedTemplate.querySelector('[data-key="UnitNo"]');
            if (unitNoElement) {
                unitNoElement.textContent = (collectionPoint.UnitNo ?? '');
            }
        
            const zipCodeElement = clonedTemplate.querySelector('[data-key="ZipCode"]');
            if (zipCodeElement) {
                zipCodeElement.textContent = collectionPoint.ZipCode ?? '';
            }
        
            const cityElement = clonedTemplate.querySelector('[data-key="City"]');
            if (cityElement) {
                cityElement.textContent = collectionPoint.City ?? '';
            }
        
            const openingHoursMonFriElement = clonedTemplate.querySelector('[data-key="OpeningHoursMonFri"]');
            if (openingHoursMonFriElement) {
                if (collectionPoint.OpeningHoursMonFri) {
                    openingHoursMonFriElement.append(collectionPoint.OpeningHoursMonFri);
                } else {
                    openingHoursMonFriElement.remove();
                }
            }
            
            const openingHoursSatElement = clonedTemplate.querySelector('[data-key="OpeningHoursSat"]');
            if (openingHoursSatElement) {
                if (collectionPoint.OpeningHoursSat) {
                    openingHoursSatElement.append(collectionPoint.OpeningHoursSat);
                } else {
                    openingHoursSatElement.remove();
                }
            }
            
            const openingHoursSunElement = clonedTemplate.querySelector('[data-key="OpeningHoursSun"]');
            if (openingHoursSunElement) {
                if (collectionPoint.OpeningHoursSun) {
                    openingHoursSunElement.append(collectionPoint.OpeningHoursSun);
                } else {
                    openingHoursSunElement.remove();
                }
            }
        
            const emailElement = clonedTemplate.querySelector('[data-key="Email"]');
            if (emailElement) {
                if(collectionPoint.Email) {
                    emailElement.append(collectionPoint.Email);
                    emailElement.href = 'mailto:' + collectionPoint.Email;
                } else {
                    emailElement.remove();
                }
            }
            
            const phoneNoElement = clonedTemplate.querySelector('[data-key="PhoneNo"]');
            if (phoneNoElement) {
                if (collectionPoint.PhoneNo) {
                    phoneNoElement.append(collectionPoint.PhoneNo);
                    phoneNoElement.href = 'tel:' + collectionPoint.PhoneNo;
                } else {
                    phoneNoElement.remove();
                }
            }

        list.appendChild(clonedTemplate);
        });
    });
})();




`